import { $ as e, C as t, F as n, L as r, R as i, S as a, U as o, _ as s, at as c, g as l, h as u, i as d, m as f, ot as p, p as m, q as h, rt as g, t as _, v, w as y } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as b, t as x } from "./i18n-lite-BcmwMblk.js";
import { t as S } from "./normalize-props-DNjMoRjC.js";
import { n as C, r as ee, t as w } from "./Cross.ce-B3B4wiAB.js";
import { n as te, t as ne } from "./Icon.ce-CkLZiCcP.js";
//#region src/webcomponents/notification-antivirus/locales/de-AT.json
var T = {}, E = {}, D = {}, O = {}, k = {}, A = { "notification-antivirus": {
	nextButtonLabel: "Suivant",
	question: "Que doit faire Philippe ?",
	notificationSubtitle: "Sécurité antivirus",
	iDontKnow: "Je ne sais pas",
	closeNotification: "Fermer la notification",
	successFeedbackTitle: "Bien joué !",
	iDontKnowFeedbackTitle: "Pas facile.",
	failureFeedbackTitle: "Eh non !",
	indeed: "effectivement, ",
	step1: {
		notification: {
			title: "Analyse quotidienne terminée",
			content: "Aucun élément dangereux n'a été détecté."
		},
		shutDownComputer: "Éteindre l’ordinateur",
		feedback: "{{indeed}}ici, la notification transmet seulement une information mais ne demande pas d’action de la part de Philippe. Il faut toujours lire attentivement les notifications de l’antivirus."
	},
	step2: {
		notification: {
			title: "Menace détectée sur la clef USB",
			content: "L’élément potentiellement dangereux a été isolé."
		},
		unplugUsb: "Débrancher la clé et ne plus l’utiliser",
		feedback: "{{indeed}}ici, la notification transmet une information importante à Philippe : il y a un problème avec la clé USB. Mieux vaut ne plus l’utiliser."
	},
	step3: {
		notification: {
			title: "Mise à jour prête à être installée",
			content: "La base de signatures de votre antivirus doit être mise à jour."
		},
		installUpdate: "Installer la mise à jour",
		feedback: "{{indeed}}ici, la notification transmet une information importante à Philippe : son antivirus doit être mis à jour. Il est important de ne pas ignorer cette notification et d’installer la mise à jour."
	}
} }, j = {}, M = {}, N = ["aria-disabled"], P = { class: "sr-only" }, F = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "Chips.ce",
	props: { variant: { type: String } },
	emits: ["click"],
	setup(e, { expose: t, emit: r }) {
		let a = f(() => e.variant === "neutral"), c = f(() => e.variant === "positive"), d = f(() => e.variant === "negative"), h = f(() => c.value ? "chips.goodAnswer" : "chips.badAnswer"), _ = o("button");
		function y() {
			a.value && x("click");
		}
		function b() {
			_.value.focus();
		}
		let x = r;
		return t({
			buttonElement: _,
			focus: b
		}), (t, r) => (n(), v("button", {
			ref: "button",
			"aria-disabled": !a.value,
			class: g({ [e.variant]: !0 }),
			type: "button",
			onClick: y
		}, [a.value ? s("", !0) : (n(), v(m, { key: 0 }, [
			c.value ? (n(), l(C, {
				key: 0,
				class: "icon"
			})) : s("", !0),
			d.value ? (n(), l(w, {
				key: 1,
				class: "icon",
				color: "#141514"
			})) : s("", !0),
			u("span", P, p(t.$t(h.value)), 1)
		], 64)), i(t.$slots, "default", {}, void 0, !0)], 10, N));
	}
}), [["styles", ["button[data-v-19a941c1]{color:#fff;background:#155dfc;border:none;border-radius:8px;flex:1;justify-content:center;align-items:center;padding:8px;font-size:14px;font-weight:700;display:flex;box-shadow:0 2px 5px #155dfc40,inset 0 -2px 5px #155dfc26,inset 0 1px 1px #fafafa1a,inset 0 3px 4px #ebebeb1a}button[data-v-19a941c1]:hover{cursor:pointer;background:#0d3897}button.positive[data-v-19a941c1]{cursor:not-allowed;background:#338436;border-radius:8px;box-shadow:0 2px 5px #31623840,inset 0 -2px 5px #31623826,inset 0 1px 1px #fafafa1a,inset 0 3px 4px #ebebeb1a}button.positive[data-v-19a941c1]:focus{background:#338436}button.negative[data-v-19a941c1]{cursor:not-allowed;color:#141514;background:#ffbe0b;border-radius:8px;box-shadow:0 2px 5px #99720740,inset 0 -2px 5px #99720726,inset 0 1px 1px #fafafa1a,inset 0 3px 4px #ebebeb1a}button.negative[data-v-19a941c1]:focus{background:#ffbe0b;outline-color:#141514}button .icon[data-v-19a941c1]{width:18px;height:18px;margin-right:4px}button[data-v-19a941c1]:focus{outline-offset:-3px;background:#0d3897;border-radius:12px;outline:1px solid #fafafa}button[data-v-19a941c1]:active:not([aria-disabled=true]){background:#041332;outline:none}"]], ["__scopeId", "data-v-19a941c1"]]), I = { class: "category-select-container" }, L = { class: "steps-wrapper" }, R = {
	"aria-hidden": "true",
	class: "steps-wrapper__stepper-count"
}, z = { class: "steps-wrapper__stepper" }, B = {
	"aria-live": "polite",
	class: "sr-only"
}, V = { class: "category-select-container-wrapper" }, H = { class: "actions" }, U = { class: "actions__title" }, W = {
	"aria-live": "polite",
	class: "actions__button-list"
}, G = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "CategorySelect.ce",
	props: {
		currentStep: { type: Number },
		totalStep: { type: Number },
		question: { type: String },
		answers: { type: Array },
		hasAnswered: { type: Boolean }
	},
	emits: ["on-answer"],
	setup(e) {
		let t = e, o = f(() => {
			let e = Math.floor(t.currentStep / t.totalStep * 100) ?? 0;
			return e > 100 ? 100 : e;
		});
		function s(e) {
			return t.hasAnswered ? e ? "positive" : "negative" : "neutral";
		}
		return (d, f) => (n(), v("div", I, [u("div", L, [
			u("p", R, p(e.currentStep) + "/" + p(e.totalStep), 1),
			u("div", z, [u("div", {
				style: c({ "--stepProgress": `${o.value}%` }),
				class: "steps-wrapper__effective-steps"
			}, null, 4)]),
			u("p", B, p(d.$t("category-select.step", {
				currentStep: e.currentStep,
				totalStep: e.totalStep
			})), 1)
		]), u("div", V, [i(d.$slots, "default", {}, void 0, !0), u("div", H, [u("p", U, p(t.question), 1), u("section", W, [(n(!0), v(m, null, r(e.answers, (e) => (n(), l(F, {
			key: e.label,
			variant: s(e.isGoodAnswer),
			onClick: (t) => d.$emit("on-answer", e.isGoodAnswer)
		}, {
			default: h(() => [a(p(e.label), 1)]),
			_: 2
		}, 1032, ["variant", "onClick"]))), 128))])])])]));
	}
}), [["styles", ["p[data-v-4c810d8f]{margin:0;font-family:Roboto,arial,\"sans-serif\"}.category-select-container[data-v-4c810d8f]{border-radius:16px;box-shadow:0 2px 5px #155dfc40,inset 0 -2px 5px #155dfc26,inset 0 1px 1px #fafafa1a,inset 0 3px 4px #ebebeb1a}.category-select-container-wrapper[data-v-4c810d8f]{padding:16px}.category-select-container-wrapper .actions__button-list[data-v-4c810d8f]{justify-content:space-between;gap:8px;display:flex}.category-select-container-wrapper .actions__title[data-v-4c810d8f]{color:#122647;margin-block:8px 16px;font-size:.875rem;font-weight:700}.steps-wrapper[data-v-4c810d8f]{background:#d0dffe;border-radius:16px 16px 0 0;align-items:center;gap:8px;padding:16px 24px;display:flex}.steps-wrapper__stepper-count[data-v-4c810d8f]{aspect-ratio:1;color:#fff;background:#0d3897;border-radius:50%;align-items:center;padding:4px;font-size:.75rem;font-weight:700;display:flex}.steps-wrapper__stepper[data-v-4c810d8f]{background:#fff;border-radius:4px;width:100%;height:8px}.steps-wrapper__effective-steps[data-v-4c810d8f]{width:var(--stepProgress);background:#0d3897;border-radius:4px;height:8px}.sr-only[data-v-4c810d8f]{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}@media screen and (width<=576px){.actions__button-list[data-v-4c810d8f]{flex-direction:column}}"]], ["__scopeId", "data-v-4c810d8f"]]), K = "data:image/svg+xml,%3csvg%20width='17'%20height='17'%20viewBox='0%200%2017%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.32104%209.82833L5.65896%208.16625C5.48632%207.99347%205.26861%207.90708%205.00583%207.90708C4.74319%207.90708%204.52549%207.99347%204.35271%208.16625C4.18007%208.33889%204.09458%208.5566%204.09625%208.81938C4.09792%209.08201%204.18507%209.29965%204.35771%209.47229L6.65313%2011.7677C6.84424%2011.9576%207.06722%2012.0525%207.32208%2012.0525C7.57681%2012.0525%207.79917%2011.9576%207.98917%2011.7677L12.6227%207.13396C12.7955%206.96132%2012.8819%206.74451%2012.8819%206.48354C12.8819%206.22243%2012.7955%206.00556%2012.6227%205.83292C12.4501%205.66014%2012.2324%205.57375%2011.9696%205.57375C11.7069%205.57375%2011.4893%205.66014%2011.3167%205.83292L7.32104%209.82833ZM8.50271%2017.0054C7.3234%2017.0054%206.21688%2016.7824%205.18313%2016.3363C4.14924%2015.8901%203.24993%2015.2848%202.48521%2014.5202C1.72063%2013.7555%201.11528%2012.8562%200.669167%2011.8223C0.223055%2010.7885%200%209.68201%200%208.50271C0%207.3234%200.223055%206.21687%200.669167%205.18312C1.11528%204.14924%201.72063%203.24993%202.48521%202.48521C3.24993%201.72062%204.14924%201.11528%205.18313%200.669167C6.21688%200.223055%207.3234%200%208.50271%200C9.68201%200%2010.7885%200.223055%2011.8223%200.669167C12.8562%201.11528%2013.7555%201.72062%2014.5202%202.48521C15.2848%203.24993%2015.8901%204.14924%2016.3363%205.18312C16.7824%206.21687%2017.0054%207.3234%2017.0054%208.50271C17.0054%209.68201%2016.7824%2010.7885%2016.3363%2011.8223C15.8901%2012.8562%2015.2848%2013.7555%2014.5202%2014.5202C13.7555%2015.2848%2012.8562%2015.8901%2011.8223%2016.3363C10.7885%2016.7824%209.68201%2017.0054%208.50271%2017.0054ZM8.50271%2015.1096C10.3505%2015.1096%2011.9136%2014.4704%2013.1921%2013.1921C14.4704%2011.9136%2015.1096%2010.3505%2015.1096%208.50271C15.1096%206.65493%2014.4704%205.09181%2013.1921%203.81333C11.9136%202.535%2010.3505%201.89583%208.50271%201.89583C6.65493%201.89583%205.09181%202.535%203.81333%203.81333C2.535%205.09181%201.89583%206.65493%201.89583%208.50271C1.89583%2010.3505%202.535%2011.9136%203.81333%2013.1921C5.09181%2014.4704%206.65493%2015.1096%208.50271%2015.1096Z'%20fill='white'/%3e%3c/svg%3e", q = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.99898%2014.3361C10.2756%2014.3361%2010.5079%2014.2425%2010.6959%2014.0552C10.8838%2013.868%2010.9777%2013.6361%2010.9777%2013.3594C10.9777%2013.0827%2010.8842%2012.8495%2010.6971%2012.6598C10.5099%2012.4702%2010.2779%2012.3754%2010.0011%2012.3754C9.7244%2012.3754%209.49211%2012.4702%209.30419%2012.6598C9.11627%2012.8495%209.02232%2013.0827%209.02232%2013.3594C9.02232%2013.6361%209.11586%2013.868%209.30294%2014.0552C9.49016%2014.2425%209.72218%2014.3361%209.99898%2014.3361ZM10%2010.8434C10.266%2010.8434%2010.4905%2010.7518%2010.6736%2010.5688C10.8565%2010.3859%2010.9479%2010.1614%2010.9479%209.89544V6.67669C10.9479%206.41072%2010.8565%206.1862%2010.6736%206.00315C10.4905%205.82023%2010.266%205.72877%2010%205.72877C9.73405%205.72877%209.50954%205.82023%209.32648%206.00315C9.14357%206.1862%209.05211%206.41072%209.05211%206.67669V9.89544C9.05211%2010.1614%209.14357%2010.3859%209.32648%2010.5688C9.50954%2010.7518%209.73405%2010.8434%2010%2010.8434ZM10%2018.5027C8.82072%2018.5027%207.71419%2018.2797%206.68044%2017.8336C5.64655%2017.3875%204.74725%2016.7821%203.98252%2016.0175C3.21794%2015.2528%202.61259%2014.3535%202.16648%2013.3196C1.72037%2012.2859%201.49731%2011.1793%201.49731%2010C1.49731%208.82072%201.72037%207.71419%202.16648%206.68044C2.61259%205.64655%203.21794%204.74724%203.98252%203.98252C4.74725%203.21794%205.64655%202.61259%206.68044%202.16648C7.71419%201.72037%208.82072%201.49731%2010%201.49731C11.1793%201.49731%2012.2859%201.72037%2013.3196%202.16648C14.3535%202.61259%2015.2528%203.21794%2016.0175%203.98252C16.7821%204.74724%2017.3875%205.64655%2017.8336%206.68044C18.2797%207.71419%2018.5027%208.82072%2018.5027%2010C18.5027%2011.1793%2018.2797%2012.2859%2017.8336%2013.3196C17.3875%2014.3535%2016.7821%2015.2528%2016.0175%2016.0175C15.2528%2016.7821%2014.3535%2017.3875%2013.3196%2017.8336C12.2859%2018.2797%2011.1793%2018.5027%2010%2018.5027ZM10%2016.6069C11.8478%2016.6069%2013.4109%2015.9677%2014.6894%2014.6894C15.9677%2013.4109%2016.6069%2011.8478%2016.6069%2010C16.6069%208.15225%2015.9677%206.58912%2014.6894%205.31065C13.4109%204.03231%2011.8478%203.39315%2010%203.39315C8.15225%203.39315%206.58912%204.03231%205.31065%205.31065C4.03231%206.58912%203.39315%208.15225%203.39315%2010C3.39315%2011.8478%204.03231%2013.4109%205.31065%2014.6894C6.58912%2015.9677%208.15225%2016.6069%2010%2016.6069Z'%20fill='%23FAFAFA'/%3e%3c/svg%3e", J = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%2021C3.71667%2021%203.47917%2020.9042%203.2875%2020.7125C3.09583%2020.5208%203%2020.2833%203%2020V19C3%2018.7167%203.09583%2018.4792%203.2875%2018.2875C3.47917%2018.0958%203.71667%2018%204%2018C4.28333%2018%204.52083%2018.0958%204.7125%2018.2875C4.90417%2018.4792%205%2018.7167%205%2019V20C5%2020.2833%204.90417%2020.5208%204.7125%2020.7125C4.52083%2020.9042%204.28333%2021%204%2021ZM8%2021C7.71667%2021%207.47917%2020.9042%207.2875%2020.7125C7.09583%2020.5208%207%2020.2833%207%2020V14.5C7%2014.2167%207.09583%2013.9792%207.2875%2013.7875C7.47917%2013.5958%207.71667%2013.5%208%2013.5C8.28333%2013.5%208.52083%2013.5958%208.7125%2013.7875C8.90417%2013.9792%209%2014.2167%209%2014.5V20C9%2020.2833%208.90417%2020.5208%208.7125%2020.7125C8.52083%2020.9042%208.28333%2021%208%2021ZM12%2021C11.7167%2021%2011.4792%2020.9042%2011.2875%2020.7125C11.0958%2020.5208%2011%2020.2833%2011%2020V16.5C11%2016.2167%2011.0958%2015.9792%2011.2875%2015.7875C11.4792%2015.5958%2011.7167%2015.5%2012%2015.5C12.2833%2015.5%2012.5208%2015.5958%2012.7125%2015.7875C12.9042%2015.9792%2013%2016.2167%2013%2016.5V20C13%2020.2833%2012.9042%2020.5208%2012.7125%2020.7125C12.5208%2020.9042%2012.2833%2021%2012%2021ZM16%2021C15.7167%2021%2015.4792%2020.9042%2015.2875%2020.7125C15.0958%2020.5208%2015%2020.2833%2015%2020V15C15%2014.7167%2015.0958%2014.4792%2015.2875%2014.2875C15.4792%2014.0958%2015.7167%2014%2016%2014C16.2833%2014%2016.5208%2014.0958%2016.7125%2014.2875C16.9042%2014.4792%2017%2014.7167%2017%2015V20C17%2020.2833%2016.9042%2020.5208%2016.7125%2020.7125C16.5208%2020.9042%2016.2833%2021%2016%2021ZM20%2021C19.7167%2021%2019.4792%2020.9042%2019.2875%2020.7125C19.0958%2020.5208%2019%2020.2833%2019%2020V11C19%2010.7167%2019.0958%2010.4792%2019.2875%2010.2875C19.4792%2010.0958%2019.7167%209.99999%2020%209.99999C20.2833%209.99999%2020.5208%2010.0958%2020.7125%2010.2875C20.9042%2010.4792%2021%2010.7167%2021%2011V20C21%2020.2833%2020.9042%2020.5208%2020.7125%2020.7125C20.5208%2020.9042%2020.2833%2021%2020%2021ZM14%2011.975C13.7333%2011.975%2013.4792%2011.925%2013.2375%2011.825C12.9958%2011.725%2012.775%2011.5833%2012.575%2011.4L10%208.82499L4.7%2014.125C4.5%2014.325%204.2625%2014.4208%203.9875%2014.4125C3.7125%2014.4042%203.475%2014.3%203.275%2014.1C3.09167%2013.9%203.00417%2013.6625%203.0125%2013.3875C3.02083%2013.1125%203.11667%2012.8833%203.3%2012.7L8.575%207.42499C8.775%207.22499%208.99583%207.07915%209.2375%206.98749C9.47917%206.89582%209.73333%206.84999%2010%206.84999C10.2667%206.84999%2010.525%206.89582%2010.775%206.98749C11.025%207.07915%2011.2417%207.22499%2011.425%207.42499L14%209.99999L19.3%204.69999C19.5%204.49999%2019.7375%204.40415%2020.0125%204.41249C20.2875%204.42082%2020.525%204.52499%2020.725%204.72499C20.9083%204.92499%2020.9958%205.16249%2020.9875%205.43749C20.9792%205.71249%2020.8833%205.94165%2020.7%206.12499L15.425%2011.4C15.2417%2011.5833%2015.025%2011.725%2014.775%2011.825C14.525%2011.925%2014.2667%2011.975%2014%2011.975Z'%20fill='%23332602'/%3e%3c/svg%3e", Y = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.5875%2021.4125C10.1958%2021.0208%2010%2020.55%2010%2020C10%2019.65%2010.0917%2019.325%2010.275%2019.025C10.4583%2018.725%2010.7%2018.4833%2011%2018.3V16H8C7.45%2016%206.97917%2015.8042%206.5875%2015.4125C6.19583%2015.0208%206%2014.55%206%2014V11.7C5.7%2011.55%205.45833%2011.325%205.275%2011.025C5.09167%2010.725%205%2010.3833%205%2010C5%209.45%205.19583%208.97917%205.5875%208.5875C5.97917%208.19583%206.45%208%207%208C7.55%208%208.02083%208.19583%208.4125%208.5875C8.80417%208.97917%209%209.45%209%2010C9%2010.3833%208.90833%2010.7167%208.725%2011C8.54167%2011.2833%208.3%2011.5167%208%2011.7V14H11V6H9L12%202L15%206H13V14H16V12H15V8H19V12H18V14C18%2014.55%2017.8042%2015.0208%2017.4125%2015.4125C17.0208%2015.8042%2016.55%2016%2016%2016H13V18.3C13.3167%2018.4667%2013.5625%2018.7%2013.7375%2019C13.9125%2019.3%2014%2019.6333%2014%2020C14%2020.55%2013.8042%2021.0208%2013.4125%2021.4125C13.0208%2021.8042%2012.55%2022%2012%2022C11.45%2022%2010.9792%2021.8042%2010.5875%2021.4125Z'%20fill='%23332602'/%3e%3c/svg%3e", X = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%2021C10.75%2021%209.57917%2020.7625%208.4875%2020.2875C7.39583%2019.8125%206.44583%2019.1708%205.6375%2018.3625C4.82917%2017.5542%204.1875%2016.6042%203.7125%2015.5125C3.2375%2014.4208%203%2013.25%203%2012C3%2010.75%203.2375%209.57917%203.7125%208.4875C4.1875%207.39583%204.82917%206.44583%205.6375%205.6375C6.44583%204.82917%207.39583%204.1875%208.4875%203.7125C9.57917%203.2375%2010.75%203%2012%203C13.3667%203%2014.6625%203.29167%2015.8875%203.875C17.1125%204.45833%2018.15%205.28333%2019%206.35V4H21V10H15V8H17.75C17.0667%207.06667%2016.225%206.33333%2015.225%205.8C14.225%205.26667%2013.15%205%2012%205C10.05%205%208.39583%205.67917%207.0375%207.0375C5.67917%208.39583%205%2010.05%205%2012C5%2013.95%205.67917%2015.6042%207.0375%2016.9625C8.39583%2018.3208%2010.05%2019%2012%2019C13.75%2019%2015.2792%2018.4333%2016.5875%2017.3C17.8958%2016.1667%2018.6667%2014.7333%2018.9%2013H20.95C20.7%2015.2833%2019.7208%2017.1875%2018.0125%2018.7125C16.3042%2020.2375%2014.3%2021%2012%2021ZM14.8%2016.2L11%2012.4V7H13V11.6L16.2%2014.8L14.8%2016.2Z'%20fill='%23332602'/%3e%3c/svg%3e", Z = {}, re = {}, ie = {}, ae = {}, oe = {}, se = { "category-select": { step: "Étape {{currentStep}} sur {{totalStep}}" } }, ce = {}, le = {};
//#endregion
//#region src/webcomponents/common/poi-design-system/category-select/translation.js
function ue() {
	x.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
		"./locales/de-AT.json": Z,
		"./locales/en.json": re,
		"./locales/es-419.json": ie,
		"./locales/es.json": ae,
		"./locales/fr-BE.json": oe,
		"./locales/fr.json": se,
		"./locales/it.json": ce,
		"./locales/nl.json": le
	}));
}
//#endregion
//#region src/webcomponents/common/poi-design-system/chips/locales/de-AT.json
var de = {}, fe = {}, pe = {}, me = {}, he = {}, ge = { chips: {
	goodAnswer: "Bonne réponse : ",
	badAnswer: "Mauvaise réponse : "
} }, _e = {}, ve = {};
//#endregion
//#region src/webcomponents/common/poi-design-system/chips/translation.js
function ye() {
	x.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
		"./locales/de-AT.json": de,
		"./locales/en.json": fe,
		"./locales/es-419.json": pe,
		"./locales/es.json": me,
		"./locales/fr-BE.json": he,
		"./locales/fr.json": ge,
		"./locales/it.json": _e,
		"./locales/nl.json": ve
	}));
}
//#endregion
//#region src/webcomponents/notification-antivirus/NotificationAntivirus.ce.vue?vue&type=script&setup=true&lang.ts
var be = {
	ref: "notification-antivirus-container",
	class: "wrapper",
	tabindex: "-1"
}, xe = { class: "notification" }, Q = ["src"], Se = { class: "notification-wrapper" }, Ce = { class: "notification-header" }, we = ["aria-level"], Te = { class: "notification-header__subtitle" }, Ee = { class: "notification-header__time" }, De = { class: "notification-content" }, Oe = {
	"aria-live": "polite",
	class: "feedback-wrapper"
}, ke = ["src"], Ae = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "NotificationAntivirus.ce",
	props: { titleLevel: { type: Number } },
	setup(r, { expose: i }) {
		ye(), ue();
		let { t: c } = b(), d = [
			{
				notification: {
					title: c("notification-antivirus.step1.notification.title"),
					subTitle: c("notification-antivirus.notificationSubtitle"),
					content: c("notification-antivirus.step1.notification.content"),
					iconName: "monitoring"
				},
				question: c("notification-antivirus.question"),
				answers: [
					{
						label: c("notification-antivirus.closeNotification"),
						isGoodAnswer: !0
					},
					{
						label: c("notification-antivirus.step1.shutDownComputer"),
						isGoodAnswer: !1
					},
					{ label: c("notification-antivirus.iDontKnow") }
				],
				successFeedback: c("notification-antivirus.step1.feedback", { indeed: c("notification-antivirus.indeed") }),
				failureFeedback: c("notification-antivirus.step1.feedback", { indeed: "" })
			},
			{
				notification: {
					title: c("notification-antivirus.step2.notification.title"),
					subTitle: c("notification-antivirus.notificationSubtitle"),
					content: c("notification-antivirus.step2.notification.content"),
					iconName: "usb"
				},
				question: c("notification-antivirus.question"),
				answers: [
					{
						label: c("notification-antivirus.closeNotification"),
						isGoodAnswer: !1
					},
					{
						label: c("notification-antivirus.step2.unplugUsb"),
						isGoodAnswer: !0
					},
					{ label: c("notification-antivirus.iDontKnow") }
				],
				successFeedback: c("notification-antivirus.step2.feedback", { indeed: c("notification-antivirus.indeed") }),
				failureFeedback: c("notification-antivirus.step2.feedback", { indeed: "" })
			},
			{
				notification: {
					title: c("notification-antivirus.step3.notification.title"),
					subTitle: c("notification-antivirus.notificationSubtitle"),
					content: c("notification-antivirus.step3.notification.content"),
					iconName: "update"
				},
				question: c("notification-antivirus.question"),
				answers: [
					{
						label: c("notification-antivirus.closeNotification"),
						isGoodAnswer: !1
					},
					{
						label: c("notification-antivirus.step3.installUpdate"),
						isGoodAnswer: !0
					},
					{ label: c("notification-antivirus.iDontKnow") }
				],
				successFeedback: c("notification-antivirus.step3.feedback", { indeed: c("notification-antivirus.indeed") }),
				failureFeedback: c("notification-antivirus.step3.feedback", { indeed: "" })
			}
		], m = e(0), g = f(() => d.at(m.value)), _ = e(!1), y = e(!1), S = o("notification-antivirus-container"), C = {
			monitoring: J,
			usb: Y,
			update: X
		}, w = f(() => new Intl.DateTimeFormat(x.language, {
			hour: "2-digit",
			minute: "2-digit"
		}).format(/* @__PURE__ */ new Date())), T = f(() => y.value === !0 ? {
			title: c("notification-antivirus.successFeedbackTitle"),
			content: g.value.successFeedback,
			icon: K
		} : y.value === !1 ? {
			title: c("notification-antivirus.failureFeedbackTitle"),
			content: g.value.failureFeedback,
			icon: q
		} : {
			title: c("notification-antivirus.iDontKnowFeedbackTitle"),
			content: g.value.failureFeedback
		});
		function E(e) {
			return e.charAt(0).toUpperCase() + e.slice(1);
		}
		function D() {
			_.value = !1, y.value = !1, m.value = 0;
		}
		function O(e) {
			_.value = !0, y.value = e;
		}
		function k() {
			_.value = !1, y.value = !1, m.value += 1, S.value.focus();
		}
		return i({ reset: D }), (e, i) => (n(), v("div", be, [t(G, {
			"has-answered": _.value,
			answers: g.value.answers,
			"current-step": m.value + 1,
			question: g.value.question,
			"total-step": d.length,
			onOnAnswer: O
		}, {
			default: h(() => [u("div", xe, [t(ne, { "background-color": "#ffbE0b" }, {
				default: h(() => [u("img", {
					src: C[g.value.notification.iconName],
					alt: ""
				}, null, 8, Q)]),
				_: 1
			}), u("div", Se, [u("div", Ce, [u("div", {
				"aria-level": r.titleLevel || 2,
				class: "notification-header__title",
				role: "heading"
			}, [u("span", Te, p(g.value.notification.subTitle), 1), a(" " + p(g.value.notification.title), 1)], 8, we), u("p", Ee, p(w.value), 1)]), u("p", De, p(g.value.notification.content), 1)])])]),
			_: 1
		}, 8, [
			"has-answered",
			"answers",
			"current-step",
			"question",
			"total-step"
		]), u("section", Oe, [t(ee, {
			"display-feedback": _.value,
			class: "feedback"
		}, {
			icon: h(() => [T.value.icon ? (n(), v("img", {
				key: 0,
				src: T.value.icon,
				alt: ""
			}, null, 8, ke)) : s("", !0)]),
			title: h(() => [a(p(T.value.title), 1)]),
			content: h(() => [a(p(E(T.value.content)), 1)]),
			_: 1
		}, 8, ["display-feedback"]), _.value && m.value + 1 < d.length ? (n(), l(te, {
			key: 0,
			class: "next-button",
			onClick: k
		}, {
			default: h(() => [a(p(e.$t("notification-antivirus.nextButtonLabel")), 1)]),
			_: 1
		})) : s("", !0)])], 512));
	}
}), [["styles", ["p{margin:0}.sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}", "[data-v-00cc149b]{color:#253858;font-family:Roboto,sans-serif}.notification[data-v-00cc149b]{background-color:#fff8e7;border-radius:8px;align-items:center;gap:8px;margin-bottom:4px;padding:8px 16px;display:flex}.notification-wrapper[data-v-00cc149b]{width:100%}.notification-header[data-v-00cc149b]{justify-content:space-between;align-items:center;display:flex}.notification-header__title[data-v-00cc149b]{color:#141514;font-size:1rem;font-weight:700}.notification-header__subtitle[data-v-00cc149b],.notification-header__time[data-v-00cc149b]{color:#666765;font-size:.75rem;font-weight:400;display:block}.feedback-wrapper[data-v-00cc149b]{margin-top:16px}.feedback-wrapper .feedback[data-v-00cc149b]{margin-bottom:16px}.feedback-wrapper .next-button[data-v-00cc149b]{margin:0 auto;display:block}@media screen and (width<=576px){.notification-header[data-v-00cc149b]{flex-direction:column;align-items:start}.notification-header .notification-header__time[data-v-00cc149b]{order:-1}}"]], ["__scopeId", "data-v-00cc149b"]]);
//#endregion
//#region src/webcomponents/notification-antivirus/notification-antivirus.ce.js
x.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": T,
	"./locales/en.json": E,
	"./locales/es-419.json": D,
	"./locales/es.json": O,
	"./locales/fr-BE.json": k,
	"./locales/fr.json": A,
	"./locales/it.json": j,
	"./locales/nl.json": M
}));
var $ = d(Ae, { configureApp(e) {
	x.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(x);
} });
$.prototype.normalizeProps = (e) => ({ titleLevel: S(e.titleLevel) }), window.customElements.define("notification-antivirus", $);
//#endregion
